<template>
  <div>
    <v-list>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="indigo">person</v-icon>
        </v-list-item-icon>

        <v-list-item-content v-if="!$store.getters.retrieveAnon">
          <v-list-item-title>{{ userName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="indigo">mdi-email</v-icon>
        </v-list-item-icon>

        <v-list-item-content v-if="!$store.getters.retrieveAnon">
          <v-list-item-title>{{ userEmail }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="indigo">mdi-map-marker</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="subtitle font-weight-medium">{{
            addressLine1
          }}</v-list-item-title>
          <v-list-item-subtitle
            class="subtitle font-weight-medium"
            v-if="addressLine2"
            >{{ addressLine2 }}</v-list-item-subtitle
          >
          <v-list-item-subtitle
            class="subtitle font-weight-medium"
            v-if="addressLine3"
            >{{ addressLine3 }}</v-list-item-subtitle
          >
          <v-list-item-subtitle
            class="subtitle font-weight-medium"
            v-if="addressLine4"
            >{{ addressLine4 }}</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle font-weight-medium">{{
            postcode
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="indigo">mdi-phone</v-icon>
        </v-list-item-icon>

        <v-list-item-content v-if="!$store.getters.retrieveAnon">
          <v-list-item-title>{{ userPhone }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["retrieveUser", "retrieveCustomerAddress"]),
    userName() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.name;
      } else {
        return null;
      }
    },

    userPhone() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.telephone_no;
      } else {
        return null;
      }
    },

    userEmail() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveUser.email_address;
      } else {
        return null;
      }
    },

    addressLine1() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_1;
      } else {
        return null;
      }
    },
    addressLine2() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_2;
      } else {
        return null;
      }
    },
    addressLine3() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_3;
      } else {
        return null;
      }
    },
    addressLine4() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_4;
      } else {
        return null;
      }
    },
    postcode() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.postcode;
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>